// Module
var code = "<h2 class=\"interiorSectionHeading\"> Change Your Due Date </h2> <p>Set up your due date for a day when you know you&#39;ll have money in your bank account.</p> ";
// Exports
export default code;